import { Reducer } from "redux";

import { ResetPassActionDispatchTypes } from "../constants/User";
import { ResetPassActionTypes } from "../models/dispatchTypes/User";
import { IResetPasswordResponse } from "../models/api/User";

const initialState: IResetPasswordResponse = {
  loading: false,
  response: false,
  error: null,
};

const ResetPassReducer: Reducer<
IResetPasswordResponse,
  ResetPassActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case ResetPassActionDispatchTypes.RESET_PASS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ResetPassActionDispatchTypes.RESET_PASS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case ResetPassActionDispatchTypes.RESET_PASS_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case ResetPassActionDispatchTypes.RESET_PASS_RESET: {
      return initialState;
    }
  }
  return state;
};

export default ResetPassReducer;
